import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

export default function DateInput({ cellValue, handleInputChange }) {
  const [value, setValue] = useState(cellValue);
  return (
    <DatePicker
      value={value ? moment(value) : null}
      onChange={(_, dateString) => {
        setValue(dateString);
        handleInputChange(dateString);
      }}
      format="YYYY-MM-DD"
    />
  );
}

DateInput.propTypes = {
  cellValue: PropTypes.string,
  handleInputChange: PropTypes.func,
};

DateInput.defaultProps = {
  cellValue: null,
  handleInputChange: () => {},
};
